module.exports = __webpack_public_path__ + "static/media/reward-card-left.277e6f80.svg";